module.exports = __webpack_public_path__ + "static/media/moon_evening.0e5be2a3.gif";